import { createMaasFormFactory } from "modules/cluster/maas";
import clusterFormActions from "../form";
import { cloudAccountsFetcher } from "state/cluster/services/create";

export const maasCloudForm = createMaasFormFactory({
  formActions: clusterFormActions,
  formModuleName: "cluster",
  getCloudAccountUid(state) {
    return state.forms.cluster.data.credential;
  },
  getOverlordUid(state) {
    const cloudAccounts = cloudAccountsFetcher.selector(state);
    const selectedCredentialUid = state.forms.cluster?.data.credential;
    const selectedCredential = cloudAccounts?.result?.find(
      (credential) => credential.metadata.uid === selectedCredentialUid
    );

    return selectedCredential?.metadata?.annotations?.overlordUid;
  },
});

function selectCredentialEffect() {
  return function (dispatch) {
    dispatch(maasCloudForm.fetchers.domainsFetcher.fetch());
  };
}

function enableLXDVmsEffect() {
  return function (dispatch) {
    dispatch(maasCloudForm.fetchers.ipamsFetcher.fetch());
  };
}

const effects = {
  selectCredentialEffect,
  enableLXDVmsEffect,
};

export default effects;
